import SearchResultsPage from 'components/pages/SearchResults';

import { getSearchContext } from 'lib/supix';

const Buscar = (props) => <SearchResultsPage {...props} />;

export const getServerSideProps = async ({ req: { headers } }) => ({
  props: { searchContext: getSearchContext(headers) },
});

export default Buscar;
